import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getEstablishment = (establishmentId: number | undefined): Promise<IGetEstablishmentViaID> => {
  return axiosDefaultApi.get(`/api/Establishments/GetEstablishmentViaID/${establishmentId}`);
};

type QueryFnType = typeof getEstablishment;

type UseGetEstablishmentOptions = {
  establishmentId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetEstablishment = ({ establishmentId , config }: UseGetEstablishmentOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getEstablishment_${establishmentId}`],
    queryFn: () => getEstablishment(establishmentId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Καταστήματος.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};